"use strict";

module.exports = [
  { level: "1", code: "1009", label: "Baptist", description: "Baptist" },
  { level: "1", code: "1034", label: "Catholic", description: "Catholic" },
  {
    level: "1",
    code: "1064",
    label: "Church of Christ",
    description: "Church of Christ"
  },
  {
    level: "1",
    code: "1069",
    label: "Episcopalian",
    description: "Episcopalian"
  },
  { level: "1", code: "1026", label: "Judaism", description: "Judaism" },
  {
    level: "1",
    code: "1027",
    label: "Latter Day Saints",
    description: "Latter Day Saints"
  },
  { level: "1", code: "1028", label: "Lutheran", description: "Lutheran" },
  { level: "1", code: "1073", label: "Methodist", description: "Methodist" },
  { level: "1", code: "1036", label: "Orthodox", description: "Orthodox" },
  {
    level: "1",
    code: "1076",
    label: "Presbyterian",
    description: "Presbyterian"
  },
  { level: "1", code: "1077", label: "Protestant", description: "Protestant" },
  {
    level: "1",
    code: "1041",
    label: "Roman Catholic",
    description: "Roman Catholic Church"
  },
  { level: "2", code: "1001", label: "Adventist", description: "Adventist" },
  {
    level: "2",
    code: "1002",
    label: "African",
    description: "Religions	African Religions"
  },
  {
    level: "2",
    code: "1003",
    label: "Afr",
    description: "-Caribbean Religions	Afro-Caribbean Religions"
  },
  {
    level: "2",
    code: "1004",
    label: "Agnosticism",
    description: "Agnosticism"
  },
  { level: "2", code: "1005", label: "Anglican", description: "Anglican" },
  { level: "2", code: "1006", label: "Animism", description: "Animism" },
  { level: "2", code: "1007", label: "Atheism", description: "Atheism" },
  {
    level: "2",
    code: "1008",
    label: "Babi & Baha'I faiths",
    description: "Babi & Baha'I faiths"
  },
  { level: "2", code: "1010", label: "Bon", description: "Bon" },
  { level: "2", code: "1011", label: "Cao", description: "Dai	Cao Dai" },
  { level: "2", code: "1012", label: "Celticism", description: "Celticism" },
  {
    level: "2",
    code: "1013",
    label: "Christian (non-Catholic, non-specific)",
    description: "Christian (non-Catholic, non-specific)"
  },
  {
    level: "2",
    code: "1014",
    label: "Confucianism",
    description: "Confucianism"
  },
  {
    level: "2",
    code: "1015",
    label: "Cyberculture",
    description: "Religions	Cyberculture Religions"
  },
  { level: "2", code: "1016", label: "Divination", description: "Divination" },
  { level: "2", code: "1017", label: "Fourth Way", description: "Fourth Way" },
  { level: "2", code: "1018", label: "Free Daism", description: "Free Daism" },
  { level: "2", code: "1019", label: "Gnosis", description: "Gnosis" },
  { level: "2", code: "1020", label: "Hinduism", description: "Hinduism" },
  { level: "2", code: "1021", label: "Humanism", description: "Humanism" },
  {
    level: "2",
    code: "1022",
    label: "Independent",
    description: "Independent"
  },
  { level: "2", code: "1023", label: "Islam", description: "Islam" },
  { level: "2", code: "1024", label: "Jainism", description: "Jainism" },
  {
    level: "2",
    code: "1025",
    label: "Jehova's Witnesses",
    description: "Jehovah's Witnesses"
  },
  { level: "2", code: "1029", label: "Mahayana", description: "Mahayana" },
  { level: "2", code: "1030", label: "Meditation", description: "Meditation" },
  {
    level: "2",
    code: "1031",
    label: "Messianic Judaism",
    description: "Messianic Judaism"
  },
  { level: "2", code: "1032", label: "Mitraism", description: "Mitraism" },
  { level: "2", code: "1033", label: "New Age", description: "New Age" },
  { level: "2", code: "1035", label: "Occult", description: "Occult" },
  { level: "2", code: "1037", label: "Paganism", description: "Paganism" },
  {
    level: "2",
    code: "1038",
    label: "Pentecostal",
    description: "Pentecostal"
  },
  {
    level: "2",
    code: "1039",
    label: "The Process",
    description: "The Process"
  },
  {
    level: "2",
    code: "1040",
    label: "Reformed/Presbyterian",
    description: "Reformed/Presbyterian"
  },
  { level: "2", code: "1042", label: "Satanism", description: "Satanism" },
  {
    level: "2",
    code: "1043",
    label: "Scientology",
    description: "Scientology"
  },
  { level: "2", code: "1044", label: "Shamanism", description: "Shamanism" },
  {
    level: "2",
    code: "1045",
    label: "Shiite (Islam)",
    description: "Shiite (Islam)"
  },
  { level: "2", code: "1046", label: "Shinto", description: "Shinto" },
  { level: "2", code: "1047", label: "Sikism", description: "Sikism" },
  {
    level: "2",
    code: "1048",
    label: "Spiritualism",
    description: "Spiritualism"
  },
  {
    level: "2",
    code: "1049",
    label: "Sunni (Islam)",
    description: "Sunni (Islam)"
  },
  { level: "2", code: "1050", label: "Taoism", description: "Taoism" },
  { level: "2", code: "1051", label: "Theravada", description: "Theravada" },
  {
    level: "2",
    code: "1052",
    label: "Unitarian-Universalism",
    description: "Unitarian-Universalism"
  },
  {
    level: "2",
    code: "1053",
    label: "Universal",
    description: "Life Church	Universal Life Church"
  },
  {
    level: "2",
    code: "1054",
    label: "Vajrayana",
    description: "(Tibetan)	Vajrayana (Tibetan)"
  },
  { level: "2", code: "1055", label: "Veda", description: "Veda" },
  { level: "2", code: "1056", label: "Voodoo", description: "Voodoo" },
  { level: "2", code: "1057", label: "Wicca", description: "Wicca" },
  { level: "2", code: "1058", label: "Yaohushua", description: "Yaohushua" },
  {
    level: "2",
    code: "1059",
    label: "Zen",
    description: "Buddhism	Zen Buddhism"
  },
  {
    level: "2",
    code: "1060",
    label: "Zoroastrianism",
    description: "Zoroastrianism"
  },
  {
    level: "2",
    code: "1061",
    label: "Assembly",
    description: "of God	Assembly of God"
  },
  { level: "2", code: "1062", label: "Brethren", description: "Brethren" },
  {
    level: "2",
    code: "1063",
    label: "Christian",
    description: "Scientist	Christian Scientist"
  },
  {
    level: "2",
    code: "1065",
    label: "Church of God",
    description: "Church of God"
  },
  {
    level: "2",
    code: "1066",
    label: "Congregational",
    description: "Congregational"
  },
  {
    level: "2",
    code: "1067",
    label: "Disciples of Christ",
    description: "Disciples of Christ"
  },
  {
    level: "2",
    code: "1068",
    label: "Eastern Orthodox",
    description: "Eastern Orthodox"
  },
  {
    level: "2",
    code: "1070",
    label: "Evangelical Covenant",
    description: "Evangelical Covenant"
  },
  { level: "2", code: "1071", label: "Friends", description: "Friends" },
  {
    level: "2",
    code: "1072",
    label: "Full Gospel",
    description: "Full Gospel"
  },
  {
    level: "2",
    code: "1074",
    label: "Native American",
    description: "Native American"
  },
  { level: "2", code: "1075", label: "Nazarene", description: "Nazarene" },
  {
    level: "2",
    code: "1078",
    label: "Protestant, No Denomination",
    description: "Protestant, No Denomination"
  },
  { level: "2", code: "1079", label: "Reformed", description: "Reformed" },
  {
    level: "2",
    code: "1080",
    label: "Salvation Army",
    description: "Salvation Army"
  },
  {
    level: "2",
    code: "1081",
    label: "Unitarian Universalist",
    description: "Unitarian Universalist"
  },
  {
    level: "2",
    code: "1082",
    label: "United Church of Christ",
    description: "United Church of Christ"
  }
];
